module.exports = __webpack_public_path__ + "img/skd-logo-dark.3cec8c16.svg";